import * as React from "react";
import "./style.css";
import { Typography, Button } from "antd";
import { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { getBatchList } from "../../../services/batch.service";
import { BulkBatchDefaultConfiguration } from "../../../services/batch.service";
import { swalNotification } from "../../../components/alret/notificztion";
import { validationErrors } from "../../../utils/Helpers";
import Pageloader from "../../../components/loader";
import FormBatchDefaultConfiguration from "../../../components/forms/FormBatchDefaultConfiguration";
const { Title } = Typography;
const BatchDefaultConfiguration = () => {
  const pagename = "Batch Default Configuration";
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  useEffect(() => {
    postLists();
  }, []);
  const postLists = async () => {
    setLoading(true);
    postListsrefresh();
  };
  const postListsrefresh = async () => {
    try {
      const resp = await getBatchList();
      const valuesDataconvert = [];
      resp.data.data.map((item) => {
        const valueObj = {
          batchLevel: item.batch.batchLevel,
          batch: item.batch.id,
          slotsPercentage: item.slotsPercentage,
          startDisplayHours: item.startDisplayHours,
          endDisplayHours: item.endDisplayHours,
        };
        valuesDataconvert.push(valueObj);
      });
      setPostData(valuesDataconvert);
    } catch (e) {
      validationErrors(e);
      throw e;
    } finally {
      setLoading(false);
    }
  };
  const initialValues = {
    batch_default_setting: postData,
  };

  const defaultConfigValuesEnable = () => {
    setIsDisabled(false);
  };
  const defaultConfigValuesDisable = () => {
    setIsDisabled(true);
  };
  const onFinish = async (values) => {
    const newData = values.batch_default_setting;
    const batch_data = [];
    newData.map((v, i) => {
      const value = v;
      delete v["batchLevel"];
      batch_data.push({ ...value });
    });
    try {
      const resp = await BulkBatchDefaultConfiguration(batch_data);
      if (resp.data.code == 200) {
        swalNotification(
          "Batch Default Configuration",
          resp.data.message,
          "success"
        );
        postListsrefresh();
      }
    } catch (error) {
      validationErrors(error);
    } finally {
      setIsDisabled(true);
    }
  };
  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>{pagename}</Title>
        </div>
        {isDisabled ? (
          <div className="pch">
            <Button onClick={defaultConfigValuesEnable}>Edit</Button>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="p-content">
        {loading ? (
          <Pageloader />
        ) : (
          <FormBatchDefaultConfiguration
            initialValues={initialValues}
            onFinish={onFinish}
            isDisabled={isDisabled}
            editCancel={defaultConfigValuesDisable}
          />
        )}
      </div>
    </div>
  );
};
export default BatchDefaultConfiguration;
